"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const two_columns_with_social_media_1 = require("@ariessolutionsio/react-ecomm-ui/dist/components/PageSections/marketing/footers/two-columns-with-social-media");
const Footer = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "bg-primary-800 py-4 md:py-16", children: (0, jsx_runtime_1.jsx)(two_columns_with_social_media_1.TwoColumnsWithSocialMedia, { ...props, extend: {
                link: {
                    palette: 'black',
                },
            }, extendedClasses: {
                links: 'hover:text-primary-200',
                svg: 'h-10 md:h-14',
            } }) }));
};
exports.Footer = Footer;
